$(document).ready(function () {
	$(window).on('resize', renderLights);
	renderLights();

	function renderLights() {
		const headerLogo = $('header .logo');
		const logoList = headerLogo.find('ul');
		const lightsOuter = $('.lights-outer');
		const container = $('header .container');

		logoList.empty();
		lightsOuter.empty();

		for (let i = 0; i < 15; i++) {
			logoList.append('<li></li>');
		}

		const lightWidth = logoList.find('li:eq(0)').outerWidth(true);
		const lightsOuterWidth = lightsOuter.width();
		const containerWidth = container.width();
		const logoWidth = headerLogo.outerWidth();

		const isMobileCentered = window.innerWidth <= 640;

		let logoLeft, logoRight;

		if (isMobileCentered) {
			logoLeft = (lightsOuterWidth - logoWidth) / 2;
		} else {
			logoLeft = (lightsOuterWidth - containerWidth) / 2;
		}

		logoRight = logoLeft + logoWidth;

		const countBefore = Math.floor(logoLeft / lightWidth);
		const countAfter = Math.floor((lightsOuterWidth - logoRight) / lightWidth);

		insertLights(0, countBefore, lightWidth, 'before');
		insertLights(logoRight, countAfter, lightWidth, 'after');

		$('header .logo li, .lights-outer li').each(function (index) {
			if (index % 2 === 0) {
				$(this).addClass('active');
			}
		});

		lightCycle();
	}

	function insertLights(startX, count, lightWidth, className) {
		const lightsOuter = $('.lights-outer');
		for (let i = 0; i < count; i++) {
			const left = Math.round(startX + i * lightWidth);
			lightsOuter.append(`<li class="${className}" style="left: ${left}px"></li>`);
		}
	}

	function lightCycle() {
		animateGroup($('li.before'), () => {
			animateGroup($('header .logo li'), () => {
				animateGroup($('li.after'), lightCycle);
			});
		});
	}

	function animateGroup($group, callback) {
		const delay = 100;
		if ($group.length === 0) return callback();

		$group.each(function (i) {
			$(this).delay(i * delay).queue(function () {
				$(this).addClass("lighten").dequeue();
			});

			$(this).delay(delay).queue(function () {
				$(this).removeClass("lighten").dequeue();
				if (i === $group.length - 1) callback();
			});
		});
	}
});
